import { api } from './api';
import { selectors } from './selectors';
import { slice } from './slice';

interface IVideoArchiveStore {
  actions: typeof slice.actions;
  selectors: typeof selectors;
  api: typeof api;
}

const videoArchiveStore: IVideoArchiveStore = {
  actions: slice.actions,
  selectors,
  api,
};

export { videoArchiveStore };
